<template>
    <div id="LeftAsideBar" :class="{active : CTI.open}" ref="LeftAsideBar">
        <div class="wrapper" @click="hide()"></div>
        <div class="menuBar">
            <div class="iconPin" v-if="CTI.pin" @click="changePin">
                <img src="../assets/IconPin.png" />
            </div>
            <div class="d-flex">
                <div class="LogoArea">
                    <router-link class="iconImage" to="../Home">
                        <img src="../assets/IconLogo.png" />
                    </router-link>
                    <div v-for="(item,index) in menu" :key="index" class="mt-2 mb-2 text-center" @click="iconActive(index),ShowMenu()">
                        <div class="iconLink d-flex align-items-center justify-content-center" :class="{active : iconNum == index}">
                            <div v-html="item.mainIcon"></div>
                        </div>
                        <span class="xs-text">{{item.mainName}}</span>
                    </div>
                </div>
                <div class="line" v-show="CTI.pin"></div>
                <div class="w-100">
                    <div v-for="(item,index) in menu" :key="index">
                        <transition name="fade" mode="out-in">
                            <div class="mainListWrap" v-if="index == iconNum" v-show="CTI.pin">
                                <transition name="fade" mode="out-in">
                                    <div class="mainListTitle" v-show="CTI.pin">{{item.mainMenuTitle}}</div>
                                </transition>
                                <div v-if="UserInfo.deptID == 'G222'">
                                    <div v-for="(items,index) in item.mainMenuList" v-show="items.childMenuName == '總部客服中心'" :key="index">
                                        <div v-b-toggle="items.childMenuCategory" variant="info" class="categoryChildName">
                                            <div class="pr-2">{{items.childMenuName}}</div>
                                            <b-icon icon="chevron-down" v-show="CTI.pin" ></b-icon>
                                        </div>
                                        <b-collapse :id="items.childMenuCategory" accordion="accordiona" role="tabpanel">
                                            <div v-for="(itemss,index) in items.childMenuList" :key="index">
                                                <div v-if="itemss.isNextChild">
                                                    <div v-b-toggle="itemss.category" variant="info" class="categoryChildName noBackbg">
                                                        <div class="d-flex align-items-center">
                                                            <div class="smallCircle"></div>
                                                            <transition name="fade" mode="out-in">
                                                                <div class="pr-2">{{itemss.categoryChildName}}</div>
                                                            </transition>
                                                        </div>
                                                        <b-icon icon="chevron-down" v-show="CTI.pin"></b-icon>
                                                    </div>
                                                    <div class="LinkWrap">
                                                        <div v-for="(itemsss,index) in itemss.categoryChildList" :key="index" class="ml-3" v-show="CTI.pin">
                                                            <b-collapse :id="itemss.category" accordion="accordionb" role="tabpanel">
                                                                <div class="categoryChildName">
                                                                    <div class="d-flex align-items-center childMenuName">
                                                                        <router-link :to="itemsss.childMenuLink"
                                                                                     class="routerLinkStyle gray-text">
                                                                            <div class="smallCircle"></div>
                                                                            {{itemsss.childMenuName}}
                                                                        </router-link>
                                                                    </div>
                                                                </div>
                                                            </b-collapse>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="!itemss.isNextChild">
                                                    <div v-for="(itemsss,indexs) in itemss.categoryChildList" class="categoryChildName" :key="indexs">
                                                        <div class="d-flex align-items-center childMenuName">
                                                            <router-link :to="itemsss.childMenuLink"
                                                                         class="routerLinkStyle gray-text">
                                                                <div class="smallCircle"></div>
                                                                {{itemsss.childMenuName}}
                                                            </router-link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-collapse>
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-for="(items,index) in item.mainMenuList" :key="index">
                                        <div v-b-toggle="items.childMenuCategory" variant="info" class="categoryChildName">
                                            <div class="pr-2">{{items.childMenuName}}</div>
                                            <b-icon icon="chevron-down" class="chevron-down" v-show="CTI.pin" ></b-icon>
                                        </div>
                                        <b-collapse :id="items.childMenuCategory" accordion="accordiona" role="tabpanel">
                                            <div v-for="(itemss,index) in items.childMenuList" :key="index">
                                                <div v-if="itemss.isNextChild">
                                                    <div v-b-toggle="itemss.category" variant="info" class="categoryChildName noBackbg">
                                                        <div class="d-flex align-items-center">
                                                            <div class="smallCircle"></div>
                                                            <transition name="fade" mode="out-in">
                                                                <div class="pr-2">{{itemss.categoryChildName}}</div>
                                                            </transition>
                                                        </div>
                                                        <b-icon icon="chevron-down" class="chevron-down" v-show="CTI.pin"></b-icon>
                                                    </div>
                                                    <div class="LinkWrap">
                                                        <div v-for="(itemsss,index) in itemss.categoryChildList" :key="index" class="ml-3" v-show="CTI.pin">
                                                            <b-collapse :id="itemss.category" accordion="accordionb" role="tabpanel">
                                                                <div class="categoryChildName">
                                                                    <div class="d-flex align-items-center childMenuName">
                                                                        <router-link :to="itemsss.childMenuLink"
                                                                                     class="routerLinkStyle gray-text">
                                                                            <div class="smallCircle"></div>
                                                                            {{itemsss.childMenuName}}
                                                                        </router-link>
                                                                    </div>
                                                                </div>
                                                            </b-collapse>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="!itemss.isNextChild">
                                                    <div v-for="(itemsss,indexs) in itemss.categoryChildList" class="categoryChildName" :key="indexs">
                                                        <div class="d-flex align-items-center childMenuName">
                                                            <router-link :to="itemsss.childMenuLink"
                                                                         class="routerLinkStyle gray-text">
                                                                <div class="smallCircle"></div>
                                                                {{itemsss.childMenuName}}
                                                            </router-link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-collapse>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
        <div class="UserInfo">
            <div class="cursor-Pointer" @click="UserInfoShow = !UserInfoShow">
                <div class="UserPic mb-2">
                    <img :src="UserInfo.pictureUrl" @error="imgError(UserInfo)" width="40" />
                </div>
                <div class="UserName text-center orange-text">
                    {{UserInfo.fullName}}
                </div>
            </div>
            <transition name="fade">

                <div class="UserMenu position-absolute" v-if="UserInfoShow">
                    <div class="position-fixed w-100 logOutWrap" @click="UserInfoShow = false"></div>
                    <div class="UserDept">
                        <div class="Penaltitle">{{UserInfo.fullName}}</div>
                        <div class="gray-text">{{UserInfo.deptName}}</div>
                    </div>
                    <div class="UserLinkWrap">
                        <!--<div>
                            <div class="d-flex UserLink">
                                <div class="mr-2">
                                    <img width="20" height="20" src="../assets/SettingsIcon.png" />
                                </div>
                                <div>
                                    個人設定
                                </div>
                            </div>
                        </div>-->
                        <div class="logOutBtn" @click="LogOut">
                            登出
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    const RegistrationTopicURL = '/API/RegistrationTopicV2'
    const GetMyServicePhoneUrl = '/API/GetServicePhone'
    const LogOutApiUrl = '/Logout/Work'

    import { mapState } from 'vuex'

    export default {
        props: ['token'],
        data() {
            return {
                UserInfo: '',
                UserInfoShow: false,
                menu: [
                    {
                        'mainMenuTitle': 'CTI',
                        'mainIcon': `<div>
                                         <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.72416 9.79651C4.58623 6.86434 6.0483 1 13.0001 1C19.9518 1 21.6898 6.86434 21.6898 9.79651M4.72416 13.1956V19.593H4.19873C2.43212 19.593 1 18.1609 1 16.3943V16.3943C1 14.6277 2.43212 13.1956 4.19873 13.1956H4.72416Z" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                            <path d="M21.2759 19.593H21.8013C23.5679 19.593 25 18.1609 25 16.3943C25 14.6277 23.5679 13.1956 21.8013 13.1956H21.2759V19.593Z" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                            <path d="M13 21.3927V22.9921C15.6207 23.1253 20.9449 21.6326 21.2759 14.5954" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                         </svg>
                                    </div>`,
                        'mainName': '客服中心',
                        'mainMenuList': [
                            {
                                "childMenuName": "總部客服中心",
                                "childMenuCategory": "callCenter",
                                "childMenuList": [
                                    {
                                        "isNextChild": true,
                                        "categoryChildName": "Dashboard",
                                        "categoryIcon": "../assets/Tasks.png",
                                        "category": "CTI",
                                        "categoryChildList":
                                            [
                                                {
                                                    "sort": 1,
                                                    "childCategory":"CTI",
                                                    "childMenuName": "總覽分析",
                                                    "childMenuLink": "/DashBoard/0800668660",
                                                    "childMenuIcon": "../assets/circle.png"
                                                }
                                            ]
                                    },
                                    {
                                        "isNextChild": false,
                                        "categoryChildList":
                                            [
                                                {
                                                    "sort": 1 ,
                                                    "childCategory":"CTI",
                                                    "childMenuName": "工作台",
                                                    "childMenuLink": "/DeskPhoneInfo/0800668660",
                                                    "childMenuIcon": "../assets/circle.png"
                                                }
                                            ]
                                    }
                                ]
                            },
                            {
                                "childMenuName": "三重客服中心",
                                "childMenuCategory": "callCenter2",
                                "childMenuList": [
                                    {
                                        "isNextChild": true,
                                        "categoryChildName": "Dashboard",
                                        "categoryIcon": "../assets/Tasks.png",
                                        "category": "CTI2",
                                        "categoryChildList":
                                            [
                                                {
                                                    "sort": 1,
                                                    "childCategory":"CTI",
                                                    "childMenuName": "總覽分析",
                                                    "childMenuLink": "/DashBoard/0800668660",
                                                    "childMenuIcon": "../assets/circle.png"
                                                }
                                            ]
                                    },
                                    {
                                        "isNextChild": false,
                                        "categoryChildList":
                                            [
                                                {
                                                    "sort": 1 ,
                                                    "childCategory":"CTI",
                                                    "childMenuName": "工作台",
                                                    "childMenuLink": "/DeskPhoneInfo/0800668660",
                                                    "childMenuIcon": "../assets/circle.png"
                                                }
                                            ]
                                    }
                                ]
                            },
                            {
                                "childMenuName": "新南客服中心",
                                "childMenuCategory": "callCenter3",
                                "childMenuList": [
                                    {
                                        "isNextChild": true,
                                        "categoryChildName": "Dashboard",
                                        "categoryIcon": "../assets/Tasks.png",
                                        "category": "CTI3",
                                        "categoryChildList":
                                            [
                                                {
                                                    "sort": 1,
                                                    "childCategory":"CTI",
                                                    "childMenuName": "總覽分析",
                                                    "childMenuLink": "/DashBoard/0800668660",
                                                    "childMenuIcon": "../assets/circle.png"
                                                }
                                            ]
                                    },
                                    {
                                        "isNextChild": false,
                                        "categoryChildList":
                                            [
                                                {
                                                    "sort": 1 ,
                                                    "childCategory":"CTI",
                                                    "childMenuName": "工作台",
                                                    "childMenuLink": "/DeskPhoneInfo/0800668660",
                                                    "childMenuIcon": "../assets/circle.png"
                                                }
                                            ]
                                    }
                                ]
                            },
                            {
                                "childMenuName": "桃園客服中心",
                                "childMenuCategory": "callCenter4",
                                "childMenuList": [
                                    {
                                        "isNextChild": true,
                                        "categoryChildName": "Dashboard",
                                        "categoryIcon": "../assets/Tasks.png",
                                        "category": "CTI4",
                                        "categoryChildList":
                                            [
                                                {
                                                    "sort": 1,
                                                    "childCategory":"CTI",
                                                    "childMenuName": "總覽分析",
                                                    "childMenuLink": "/DashBoard/0800668660",
                                                    "childMenuIcon": "../assets/circle.png"
                                                }
                                            ]
                                    },
                                    {
                                        "isNextChild": false,
                                        "categoryChildList":
                                            [
                                                {
                                                    "sort": 1 ,
                                                    "childCategory":"CTI",
                                                    "childMenuName": "工作台",
                                                    "childMenuLink": "/DeskPhoneInfo/0800668660",
                                                    "childMenuIcon": "../assets/circle.png"
                                                }
                                            ]
                                    }
                                ]
                            }
                        ]
                    },
                ],
                visible: true,
                iconNum: '0',
                isTrue: true,
            }
        },
        methods: {
            imgError(item) {
                item.pictureUrl = require('../assets/DefaultPic.png')
            },
            hide() {
                this.$store.dispatch('handchangeOpen', false)
                this.$refs.LeftAsideBar.style.left = "-90px"
            },
            iconActive(index) {
                this.iconNum = index
            },
            resize() {
                //為了更新圖表觸發resize事件
                setTimeout(function () {
                    var myEvent = new Event('resize');
                    window.dispatchEvent(myEvent);
                }, 350)

            },
            changePin() {
                let _this = this
                this.isTrue = !this.CTI.pin
                this.$store.dispatch('handChangePin', this.isTrue)

                if (!this.CTI.pin) {
                    _this.$refs.LeftAsideBar.style.width = "90px"
                    _this.$refs.LeftAsideBar.style.minWidth = "90px"
                    _this.$refs.LeftAsideBar.style.position = "fixed"

                } else {
                    this.$refs.LeftAsideBar.style.width = "280px"
                    _this.$refs.LeftAsideBar.style.minWidth = "280px"
                    _this.$refs.LeftAsideBar.style.position = "fixed"
                }
                //為了更新圖表觸發resize事件

                this.resize()
            },
            ShowMenu() {
                this.$refs.LeftAsideBar.style.width = "280px"
                this.$refs.LeftAsideBar.style.minWidth = "280px"
                this.$store.dispatch('handChangePin', true)
                this.resize()
            },
            LogOut() {
                let _this = this
                let ServicePhoneID

                localStorage.clear();
                _this.$store.dispatch('handGetUserInfo', '')
                _this.$store.dispatch('handSetGlobalToken', '')
                _this.$store.dispatch('handSetGlobalLocation', '')
                _this.$router.push({ name: 'Login' });

            },
        },
        computed: {
            ...mapState(['CTI'])
        },
        mounted() {
            let storage = JSON.parse(localStorage.getItem("UserInfo"));
            this.UserInfo = storage
            this.$refs.LeftAsideBar.style.width = "280px"
            this.$refs.LeftAsideBar.style.minWidth = "280px"
            this.$store.dispatch('handChangePin', true)
        }
    }
</script>

<style>
    #LeftAsideBar .LinkWrap {
        overflow-y: scroll;
        max-height: calc(100vh - 178px);
    }

    #LeftAsideBar .mainListWrap {
        overflow-y: scroll;
        height: 100vh;
    }


        #LeftAsideBar .LinkWrap::-webkit-scrollbar, #LeftAsideBar .mainListWrap::-webkit-scrollbar {
            width: 0px;
            background-color: #23262b;
            cursor: pointer;
        }

        #LeftAsideBar .LinkWrap::-webkit-scrollbar-thumb, #LeftAsideBar .mainListWrap::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: #1d1e24;
        }


        #LeftAsideBar .LinkWrap:hover::-webkit-scrollbar, #LeftAsideBar .mainListWrap:hover::-webkit-scrollbar {
            width: 0px;
            background-color: #23262b;
            cursor: pointer;
        }

        #LeftAsideBar .LinkWrap:hover::-webkit-scrollbar-thumb, #LeftAsideBar .mainListWrap:hover::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: #1d1e24;
        }



    #LeftAsideBar .UserInfo {
        position: fixed;
        bottom: 100px;
        left: 17px;
    }

        #LeftAsideBar .UserInfo .UserPic {
            width: 50px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px solid #FF955C;
            border-radius: 50%;
            background: #23262b;
            cursor: pointer;
        }

            #LeftAsideBar .UserInfo .UserPic img {
                border-radius: 50%;
            }

        #LeftAsideBar .UserInfo .UserMenu {
            left: 70px;
            bottom: 3px;
            width: 150px;
            height: auto;
            -webkit-box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.5);
            box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.5);
            border-radius: 20px;
            background: #23262B;
            border: 1px solid #30323B;
            padding: 25px 10px;
            z-index: 10;
        }

        #LeftAsideBar .UserInfo .UserLinkWrap {
            padding-top: 15px;
        }

        #LeftAsideBar .UserInfo .UserLink {
            /*background: #0090FF;*/
            border-radius: 10px;
            height: 40px;
            width: 100%;
            display: flex;
            align-items: center;
            padding: 0 15px;
            cursor: pointer;
        }

        #LeftAsideBar .UserInfo .UserDept {
            padding: 0 15px 15px 15px;
            border-bottom: 1px solid #30323B;
        }


        #LeftAsideBar .UserInfo .logOutWrap {
            height: 100vh;
            left: 0;
            top: 0;
            z-index: -1;
        }

        #LeftAsideBar .UserInfo .logOutBtn {
            width: 90px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #FF955C;
            border-radius: 10px;
            margin: 0 15px;
            cursor: pointer;
        }


    #LeftAsideBar {
        position: fixed;
        background: #23262B;
        height: -webkit-fill-available;
        display: flex;
        flex-direction: column;
        transition: .3s;
        z-index: 999;
        left: 0px !important;
    }

        #LeftAsideBar .Logout {
            text-align: center;
            position: fixed;
            bottom: 0;
            left: 15px;
        }

        #LeftAsideBar .menuBar {
            color: #93959C;
        }

            #LeftAsideBar .menuBar .LogoArea {
                padding: 30px 22px;
            }

            #LeftAsideBar .menuBar .iconLink {
                width: 48px;
                height: 48px;
                margin: 10px 0;
                border-radius: 10px;
                cursor: pointer;
                transition: .3s;
            }

                #LeftAsideBar .menuBar .iconLink.active {
                    background: #0090FF;
                }

            #LeftAsideBar .menuBar .iconImage {
                display:block;
                width: 35px;
                height: 35px;
                margin: 0 auto 60px auto;
            }

            #LeftAsideBar .menuBar .line {
                width: 1px;
                height: 100vh;
                background: #30323B;
            }

        #LeftAsideBar .mainListTitle {
            padding: 27px 30px 0 30px;
            margin-bottom: 55px;
            white-space: nowrap;
            font-size: 24px;
            color: #FCFCFC;
        }

        #LeftAsideBar .categoryChildName {
            width: 164px;
            height: 51px;
            padding: 20px 10px 20px 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            transition: .3s;
            position: relative;
            white-space: nowrap;
            margin: 0 auto;
            border-radius: 10px;
        }
            #LeftAsideBar .categoryChildName.not-collapsed {
                color: #0090FF !important;
            }

            #LeftAsideBar .categoryChildName .chevron-down {
                color: #93959C !important;
                transform: rotate(-90deg);
                transition:.3s;
            }

            #LeftAsideBar .categoryChildName.not-collapsed .chevron-down {
                color: #0090FF !important;
                transform: rotate(0deg);
            }


    .smallCircle {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #93959C;
        margin-right: 15px;
    }

    #LeftAsideBar .categoryChildName.not-collapsed {
        background: #1D1E24;
        color: #FCFCFC;
    }

        #LeftAsideBar .categoryChildName.not-collapsed.noBackbg {
            background: transparent;
            color: #0090FF;
            font-weight: bold;
        }

            #LeftAsideBar .categoryChildName.not-collapsed.noBackbg .smallCircle {
                background: #0090FF;
            }

    #LeftAsideBar .wrapper {
        width: 0px;
        height: 0px;
    }

    .iconPin {
        position: absolute;
        right: 26px;
        top: 33px;
        cursor: pointer;
        z-index: 99;
    }

    #LeftAsideBar .routerLinkStyle {
        display: flex;
        align-items: center;
        white-space: nowrap;
    }
    /* #LeftAsideBar .childMenuName {
        padding: 15px 30px 15px 30px;
    }*/

    #LeftAsideBar .childMenuName .router-link-active {
        color: #0090FF;
    }

        #LeftAsideBar .childMenuName .router-link-active .smallCircle {
            background: #0090FF;
        }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    @media screen and (max-width: 992px) {
        #LeftAsideBar {
            position: absolute;
            left: -360px !important;
        }

            #LeftAsideBar.active {
                position: fixed;
                left: 0px !important;
            }

        .iconPin {
            display: none;
        }

        #LeftAsideBar.active .wrapper {
            width: 100%;
            height: 100%;
            z-index: -10;
            position: fixed;
        }

        #LeftAsideBar .UserInfo {
            position: fixed;
            bottom: 15px;
            left: 17px;
        }
    }
</style>

